module.exports = __webpack_public_path__ + "static/filter_none-5a2ea6c5ba5e2d6c0ab73f7575a32609.png";